export const RANK_COLORS = {
    4: '#009E82', // SuperFood
    3: '#FF3A3A', // Avoid
    2: '#FFAB01', // Minimize
    1: '#2F5CFF', // Enjoy
  };
  
  export const RANK_NAMES = {
    4: 'SuperFood',
    3: 'Avoid',
    2: 'Minimize',
    1: 'Enjoy',
  };